module.exports = __webpack_public_path__ + "img/XiaomiMi11Lite.def5842e.png";